/**
 * Tileset registry: map layers reference tilesets by id (`MapLayerData.tileset`); chapter/asset
 * builders register which texture key (and tile geometry) backs each id. Unregistered ids fall
 * back to a texture of the same key.
 */
export interface TilesetDef {
  id: string;
  /** Phaser texture key (spritesheet-style image, tiles read left→right, top→bottom). */
  texture: string;
  tileWidth?: number;
  tileHeight?: number;
  margin?: number;
  spacing?: number;
}

const registry = new Map<string, TilesetDef>();

export function registerTileset(def: TilesetDef): void {
  registry.set(def.id, { ...def });
}

export function getTileset(id: string): TilesetDef | undefined {
  return registry.get(id);
}

/** Registered def, or a default def assuming the texture key equals the id. */
export function resolveTileset(id: string): TilesetDef {
  return registry.get(id) ?? { id, texture: id };
}

export function listTilesets(): TilesetDef[] {
  return [...registry.values()];
}

export function clearTilesets(): void {
  registry.clear();
}
